import { JoinTableRow } from '@components/JoinTable';
import { MEMBERSHIPS, PLAN_NAMES } from '@lib/constants';

export const FREE_PLAN_LIST_ITEMS = [
  '❌ AI Transfers and paid features not included',
  'Get your team rated by our AI',
  'Access to Discord',
  'Live rank',
  'Mini-league analyser',
  'Access to Ben Crellin’s calendar sheet',
  'Price change predictor'
];

export const NOT_INCLUDED_LIST_ITEMS = ['Member resources'];

export const JOIN_MEMBERSHIP_PLANS = {
  STARTER: {
    yearlyId: MEMBERSHIPS.STARTER_YEARLY_ID,
    monthlyId: MEMBERSHIPS.STARTER_MONTHLY_ID,
    numberOfListItemsIncluded: 11,
    name: 'STARTER'
  },
  PRO: {
    yearlyId: MEMBERSHIPS.PRO_YEARLY_ID,
    monthlyId: MEMBERSHIPS.PRO_YEARLY_ID,
    numberOfListItemsIncluded: 14,
    name: 'PRO'
  },
  ULTRA: {
    yearlyId: MEMBERSHIPS.ULTRA_YEARLY_ID,
    monthlyId: MEMBERSHIPS.ULTRA_MONTHLY_ID,
    numberOfListItemsIncluded: 16,
    name: 'ULTRA'
  },
  FREE: {
    yearlyId: MEMBERSHIPS.FREE_ID,
    monthlyId: MEMBERSHIPS.FREE_ID,
    planListItems: FREE_PLAN_LIST_ITEMS,
    notIncludedListItems: NOT_INCLUDED_LIST_ITEMS,
    name: 'FREE'
  }
};

export const JOIN_PAGE_REVIEWS = [
  {
    userName: 'iceb0y69',
    reviewText:
      'This app is the perfect companion to those that are new to FPL and those that want to improve their rank and defeat their mini league rivals. All the resources you need in one simple app!'
  },
  {
    userName: 'SimmoJon',
    reviewText:
      'The app has transformed both my understanding and enjoyment of playing Fantasy Football as the analysis and conclusions are extremely well presented and the community is great.'
  },
  {
    userName: 'Nemo55555',
    reviewText:
      "The app has been a game changer. I's been amazing to be able to access such a wealth of data. This is the most useful resource for me as an FPL manager and I'd highly recommend a Hub membership."
  },
  {
    userName: 'Mjb500xyz',
    reviewText:
      "This is so useful and user-friendly, you can access all the content in one place and it’s easy to navigate. There is so much content on here, thanks to a great community, and I can't recommend it highly enough."
  }
];

export type JoinTableType = {
  rows: JoinTableRow[];
  tableHeaders: {
    header: string;
    subHeader?: string;
    monthlyId?: number;
    yearlyId?: number;
    discountedAnnualPerMonthPrice?: string;
    fullAnnualPerMonthPrice?: string;
    lookup_key?: 'starter_yearly' | 'pro_yearly' | 'ultra_yearly';
  }[];
  isAnnual?: boolean;
  backgroundColor?: boolean;
  userMembershipIds?: number[];
  variant?: 'join' | 'member-upgrade';
  plansAreLoading?: boolean;
};

export const JoinTableInfo: JoinTableType = {
  tableHeaders: [
    { header: '' },
    {
      header: PLAN_NAMES.STARTER,
      subHeader: 'Start getting an edge',
      yearlyId: MEMBERSHIPS.STARTER_YEARLY_ID,
      discountedAnnualPerMonthPrice: `£2.49`,
      fullAnnualPerMonthPrice: `£4.98`,
      lookup_key: 'starter_yearly'
    },
    {
      header: PLAN_NAMES.PRO,
      subHeader: 'Everything you need to Win',
      yearlyId: MEMBERSHIPS.PRO_YEARLY_ID,
      discountedAnnualPerMonthPrice: `£3.99`,
      fullAnnualPerMonthPrice: `£7.98`,
      lookup_key: 'pro_yearly'
    },
    {
      header: PLAN_NAMES.ULTRA,
      subHeader: 'Personalised Expert Insights',
      yearlyId: MEMBERSHIPS.ULTRA_YEARLY_ID,
      discountedAnnualPerMonthPrice: `£14.99`,
      fullAnnualPerMonthPrice: `£29.98`,
      lookup_key: 'ultra_yearly'
    }
  ],
  rows: [
    { type: 'divider', text: 'My Team & Hub AI' },
    {
      type: 'feature',
      text: 'Recommended AI transfers',
      starter: true,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: 'Team Rated by AI',
      starter: true,
      pro: true,
      ultra: true
    },
    {
      type: 'feature',
      text: 'My Team Predicted Points',
      starter: true,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: 'Team and Chip planning',
      starter: true,
      pro: true,
      ultra: true
    },
    {
      type: 'feature',
      text: 'My Team Live Rank',
      starter: true,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: 'AI Teams of the week',
      starter: false,
      pro: true,
      ultra: true
    },
    { type: 'divider', text: 'Community features' },
    {
      type: 'feature',
      text: 'Discord',
      starter: true,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: 'Access to Whatsapp communities',
      starter: false,
      pro: true,
      ultra: true
    },
    {
      type: 'feature',
      text: ' Ben Crellin’s planning sheet',
      starter: false,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    { type: 'divider', text: 'Stats tools' },
    {
      type: 'feature',
      text: 'OPTA Stats Package',
      starter: false,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: 'Predicted Points Tool',
      starter: false,
      pro: true,
      ultra: true
    },
    {
      type: 'feature',
      text: 'Player comparison tool',
      starter: false,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: ' Fixture analyser',
      starter: false,
      pro: true,
      ultra: true
    },
    {
      type: 'feature',
      text: 'Player profiler',
      starter: false,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    { type: 'divider', text: 'Articles & Team Reveals' },
    {
      type: 'feature',
      text: 'Expert Team Reveals',
      starter: false,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: '300+ exclusive ‘Pro’ articles a year ',
      starter: false,
      pro: true,
      ultra: true
    },
    {
      type: 'feature',
      text: 'Team news',
      starter: false,
      pro: true,
      ultra: true,
      backgroundColor: true
    },
    { type: 'divider', text: 'Extra' },
    {
      type: 'feature',
      text: '1 Personalised expert team review per month',
      starter: false,
      pro: false,
      ultra: true
    },
    {
      type: 'feature',
      text: 'Ultra Club Secret Whatsapp community with Hub Founder, Will Thomas and Ultra expert, Rich Clarke ',
      starter: false,
      pro: false,
      ultra: true,
      backgroundColor: true
    },
    {
      type: 'feature',
      text: 'Invite to our end of year meet up',
      starter: false,
      pro: false,
      ultra: true
    },
    {
      type: 'feature',
      text: 'Monthly group Zoom calls with Ultra expert, Rich Clarke',
      starter: false,
      pro: false,
      ultra: true,
      backgroundColor: true
    }
  ]
};

export const MOBILE_COLLAPSED_LIST_ITEMS = {
  starter: [
    'AI transfers tailored to your team',
    'Predict your points every gameweek',
    'Live mini-leagues, price changes & rank'
  ],
  pro: [
    'Expert & AI team reveals',
    '10+ Pro tools to help you win',
    'Exclusive WhatsApp community membership'
  ],
  ultra: [
    'Monthly personalised expert team review',
    'Secret Ultra WhatsApp group with Elite managers',
    'Monthly Zoom masterminds'
  ],
  free: [...FREE_PLAN_LIST_ITEMS.slice(0, 3)]
};

export const MOBILE_EXPANDED_LIST_ITEMS = {
  starter: [
    'AI transfers tailored to your team',
    'AI team rating',
    'Predict your points each gameweek',
    'Plan chips & future gameweeks',
    'Real‑time rank, mini‑leagues & prices',
    'Members-only Discord community'
  ],
  pro: [
    'Full access to My Team',
    'Expert & AI team reveals',
    'Predicted points tool',
    'Fixture analyser',
    'Player profiler',
    'Team & chip planning',
    'Live rank & price tracker',
    'Exclusive WhatsApp community',
    'Ben Crellin planning sheet',
    '300+ Pro-only articles a year',
    'Team news updates'
  ],
  ultra: [
    'Monthly personalised expert team review',
    'Secret Ultra WhatsApp group with Elite managers',
    'Monthly Zoom masterminds',
    'Invite to end-of-year party'
  ],
  free: [...FREE_PLAN_LIST_ITEMS.slice(0, 3)]
};

// Hardcoded currency symbols (fallback)
const CURRENCY_SYMBOLS = {
  aed: 'د.إ', // UAE Dirham
  aud: 'A$', // Australian Dollar
  bam: 'KM', // Bosnia-Herzegovina Convertible Mark
  bdt: '৳', // Bangladeshi Taka
  bgn: 'лв', // Bulgarian Lev
  bmd: '$', // Bermudian Dollar
  bnd: 'B$', // Brunei Dollar
  cad: 'C$', // Canadian Dollar
  chf: 'CHF', // Swiss Franc
  cny: '¥', // Chinese Yuan
  czk: 'Kč', // Czech Koruna
  dkk: 'kr', // Danish Krone
  egp: 'E£', // Egyptian Pound
  eur: '€', // Euro
  gbp: '£', // British Pound
  hkd: 'HK$', // Hong Kong Dollar
  huf: 'Ft', // Hungarian Forint
  ils: '₪', // Israeli Shekel
  inr: '₹', // Indian Rupee
  isk: 'kr', // Icelandic Króna
  jmd: 'J$', // Jamaican Dollar
  jpy: '¥', // Japanese Yen
  kes: 'KSh', // Kenyan Shilling
  kzt: '₸', // Kazakhstani Tenge
  mad: 'د.م.', // Moroccan Dirham
  mur: '₨', // Mauritian Rupee
  mvr: 'Rf', // Maldivian Rufiyaa
  mxn: '$', // Mexican Peso
  myr: 'RM', // Malaysian Ringgit
  ngn: '₦', // Nigerian Naira
  nok: 'kr', // Norwegian Krone
  nzd: 'NZ$', // New Zealand Dollar
  pen: 'S/', // Peruvian Sol
  pkr: '₨', // Pakistani Rupee
  pln: 'zł', // Polish Złoty
  qar: 'ر.ق', // Qatari Riyal
  ron: 'lei', // Romanian Leu
  rsd: 'дин.', // Serbian Dinar
  sar: 'ر.س', // Saudi Riyal
  sek: 'kr', // Swedish Krona
  sgd: 'S$', // Singapore Dollar
  thb: '฿', // Thai Baht
  try: '₺', // Turkish Lira
  ttd: 'TT$', // Trinidad and Tobago Dollar
  uah: '₴', // Ukrainian Hryvnia
  usd: '$', // US Dollar
  vnd: '₫', // Vietnamese Dong
  zar: 'R' // South African Rand
};

export const getCurrencySymbol = (currencyCode) => {
  const code = currencyCode.toLowerCase();

  try {
    const formatter = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currencyCode.toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    const formatted = formatter.format(0);
    const symbol = formatted.replace(/[\d\s.,]/g, '').trim();

    if (!symbol || symbol === currencyCode.toUpperCase() || symbol.length > 4) {
      return CURRENCY_SYMBOLS[code] || currencyCode.toUpperCase();
    }

    return symbol;
  } catch (error) {
    return CURRENCY_SYMBOLS[code] || currencyCode.toUpperCase();
  }
};

export const formatPriceWithSymbol = (amount, currencyCode) => {
  const symbol = getCurrencySymbol(currencyCode);

  const symbolAfterCurrencies = [
    'czk',
    'dkk',
    'nok',
    'sek',
    'isk',
    'huf',
    'pln',
    'ron'
  ];
  const isSymbolAfter = symbolAfterCurrencies.includes(
    currencyCode.toLowerCase()
  );

  const formattedAmount = new Intl.NumberFormat('en', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);

  return isSymbolAfter
    ? `${formattedAmount} ${symbol}`
    : `${symbol}${formattedAmount}`;
};

type GetPriceOptions = {
  includeFormatted?: boolean;
  includeSymbol?: boolean;
  /**
   * Percentage discount applied to the displayed price. Callers pass the
   * effective discount resolved from the Sanity marketing copy singleton
   * (promoDiscountPercent + promoPricingEnabled) so marketing can keep it
   * in step with the Stripe default checkout coupon. Omitted means no
   * discount.
   */
  discountPercent?: number;
};

type PriceResult = {
  amount: number;
  currency: string;
  formattedPriceWithSymbol?: string;
  comparisonFormattedPriceWithSymbol?: string;
  symbol?: string;
};

export const getPriceForCurrency = (
  plans: any,
  lookupKey: string,
  currencyCode = 'gbp',
  options: GetPriceOptions = {}
) => {
  if (!plans || !plans.data) return null;

  const priceObj = plans.data.find((price) => price.lookup_key === lookupKey);

  if (!priceObj) return null;

  const normalizedCurrency = currencyCode.toLowerCase();

  let unitAmount;
  let finalCurrency = normalizedCurrency; // Track the actual currency being used

  if (normalizedCurrency === 'gbp') {
    unitAmount = priceObj.unit_amount;
  } else if (
    priceObj.currency_options &&
    priceObj.currency_options[normalizedCurrency]
  ) {
    unitAmount = priceObj.currency_options[normalizedCurrency].unit_amount;
  } else {
    // Fallback to GBP for both amount AND currency
    unitAmount = priceObj.unit_amount;
    finalCurrency = 'gbp'; // Set currency to GBP when falling back
  }

  const {
    includeFormatted = true,
    includeSymbol = true,
    discountPercent = 0
  } = options;

  const baseMonthlyAmount = unitAmount / 12 / 100;
  // A discountPercent of 50 gives us 50% off (multiply by 0.5)
  const discountMultiplier = 1 - discountPercent / 100;
  const monthlyAmount = baseMonthlyAmount * discountMultiplier;

  const result: PriceResult = {
    amount: monthlyAmount,
    currency: finalCurrency // Use the final currency, not the requested one
  };

  if (includeFormatted) {
    result.formattedPriceWithSymbol = formatPriceWithSymbol(
      monthlyAmount,
      finalCurrency
    );
    result.comparisonFormattedPriceWithSymbol = formatPriceWithSymbol(
      baseMonthlyAmount,
      finalCurrency
    );
  }

  if (includeSymbol) {
    result.symbol = getCurrencySymbol(finalCurrency);
  }

  return result;
};
